import "../styles/default.scss";

import React from "react";

import withPortfolioSummary from "../../../../../hocs/withPortfolioSummary";
import PortfolioSummaryItem from "../../PortfolioSummaryItem";

const PortfolioSummary = ({
  items,
  errors
}: {
  errors?: { [key: string]: string }
}) => {
  return (
    <div className="portfolio-summary">
      {items.map((item, index) => {
        const { key: itemKey, ...itemProps } = item;
        const errorMessage = errors?.[itemKey];

        return (
          <PortfolioSummaryItem
            key={itemKey ?? index}
            errorMessage={errorMessage}
            {...itemProps}
          />
        );
      })}
    </div>
  );
};

PortfolioSummary.propTypes = {};

export default withPortfolioSummary(PortfolioSummary);
